// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalWorkspaceDelete_base__5DShx","label":"useModalWorkspaceDelete_label__cm1L5"};